var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 7.999h1.278l2.018-2.076-1.442-1.442-3.356 3.356.164.162zm4.505-1.573a.5.5 0 0 1-.439.14L6.2 8.998H2.75l-.455-.452A1 1 0 0 1 2.29 7.13l3.403-3.403a.5.5 0 0 1 .612-.613l.615-.614a1 1 0 0 1 1.414 0l1.424 1.424a1 1 0 0 1 .01 1.404l-.627.645a.5.5 0 0 1-.137.453M7.628 3.207l-.567.567 1.432 1.432.559-.575zM1.75 9.249a.5.5 0 0 0 0 1h8.5a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  })));
});
const SvgTextEditErasersmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextEditErasersmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjUgNy45OTg3OUw0LjUwMDIgNy45OTg3OUw1Ljc3NzYgNy45OTkwM0w3Ljc5NTYgNS45MjM0Mkw2LjM1MzU3IDQuNDgxMzlMMi45OTgyMSA3LjgzNjc1TDMuMTYxOCA3Ljk5ODc5SDQuNVpNOS4wMDUyMyA2LjQyNTkzQzguODg1ODQgNi41NDUzMiA4LjcyMTA5IDYuNTkxNzEgOC41NjY0NSA2LjU2NTFMNi4yIDguOTk5MTJMNC41IDguOTk4NzlMMi43NTAzOSA4Ljk5ODc5TDIuMjk0NSA4LjU0NzIzQzEuOTAwNzggOC4xNTcyNyAxLjg5OTI2IDcuNTIxNDkgMi4yOTExIDcuMTI5NjRMNS42OTM3NyAzLjcyNjk4QzUuNjQ5MjIgMy41NjAxNyA1LjY5MjM4IDMuMzc0ODIgNS44MjMyNSAzLjI0Mzk1QzUuOTU0MTEgMy4xMTMwOSA2LjEzOTQ3IDMuMDY5OTMgNi4zMDYyOCAzLjExNDQ3TDYuOTIwODIgMi40OTk5MkM3LjMxMTM1IDIuMTA5NCA3Ljk0NDUxIDIuMTA5NCA4LjMzNTA0IDIuNDk5OTJMOS43NTkxMyAzLjkyNDAyQzEwLjE0NTggNC4zMTA2NiAxMC4xNTAyIDQuOTM2MTcgOS43NjkwMSA1LjMyODIxTDkuMTQxODIgNS45NzMzMkM5LjE3MzcyIDYuMTMxOSA5LjEyODE5IDYuMzAyOTcgOS4wMDUyMyA2LjQyNTkzWk03LjYyNzkzIDMuMjA3MDNMNy4wNjA2OCAzLjc3NDI4TDguNDkyNzYgNS4yMDYzNkw5LjA1MjAzIDQuNjMxMTNMNy42Mjc5MyAzLjIwNzAzWk0xLjc1IDkuMjQ5MUMxLjQ3Mzg2IDkuMjQ5MSAxLjI1IDkuNDcyOTYgMS4yNSA5Ljc0OTFDMS4yNSAxMC4wMjUyIDEuNDczODYgMTAuMjQ5MSAxLjc1IDEwLjI0OTFIMTAuMjVDMTAuNTI2MSAxMC4yNDkxIDEwLjc1IDEwLjAyNTIgMTAuNzUgOS43NDkxQzEwLjc1IDkuNDcyOTYgMTAuNTI2MSA5LjI0OTEgMTAuMjUgOS4yNDkxSDEuNzVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";